<template>
  <div class="home_wrap">
    <van-row class="topSection">
      <van-col span="4" style="text-align: left">
        <img
          src="../images/common/backArrow.png"
          @click="$router.back()"
          class="imageback"
        />
      </van-col>
      <van-col span="20" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700">{{
          $t("setWallet.modifyWallet")
        }}</span>
      </van-col>
    </van-row>
    <van-row>
      <div class="wrap">
       
        <!-- ---------- wallet ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">
              {{ $t("setWallet.modifyWallet") }}:
            </p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/OTP.png" alt=""
          /></span>
          <input type="text" v-model="wallet" />
        </div>
        <van-row>
          <van-col span="24">
            <div
              class="confirm_btn"
              :class="wallet != '' ? '' : 'no_touch'"
              @click="wallet != null ? setNewWalletAddress() : ''"
            >
              {{ $t("setWallet.modify") }}
            </div>
          </van-col>
        </van-row>
      </div>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Row).use(Col);

export default {
  name: "setwallet",
  data() {
    return {
      wallet: "",
      account: ""
    };
  },
  props: ["walletHas"],
  mounted() {
    
    if (this.walletHas) this.getWalletDetails();
  },
  methods: {
    setNewWalletAddress() {
      Fetch("/finance/changewallet", {
        wallet_address: this.wallet,
      }).then((r) => {
        this.$toast.success();
      });
    },
    getWalletDetails() {
      Fetch("/finance/user_bank_list", {
        type: 2,
      }).then((r) => {
        this.wallet = r.data.wid;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px 15px 20px;
}

.imageback {
  height: 30px;
  width: auto;
}

.no_touch {
  pointer-events: none;
}

.wrap {
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 25px 15px;
  background: #ebebeb29;
  margin: 10px;
}

.confirm_btn.no_touch {
  color: rgba(255, 255, 255, 0.5);
}

.confirm_btn {
  height: 50px;
  line-height: 46px;
  font-size: 24px;
  width: 100%;
  border-radius: 15px;
  color: #ffffff;
  text-align: center;
  border: 1px solid #ffffff;
  margin-top: 60px;
  background: linear-gradient(
    117deg,
    rgba(254, 166, 0, 1) 0%,
    rgba(255, 188, 0, 1) 100%
  );
}

.labelText {
  color: #ffffff;
  padding: 4px 10px;
  font-size: 14px;
}

.item {
  height: 46px;
  border: 1px solid #ffffff;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 9px;
  border-radius: 20px;
  background: #d4dddfde;
  .icon {
    width: 70px;
    height: 27px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    img {
      width: 27px;
      height: 27px;
    }
  }
  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}
</style>
